import { BookingSearchContext } from "@/lib/bookingSearch/context"
import { consumeContext } from "@/lib/consume/context"

export const consumeBookingSearch = consumeContext({
  Context: BookingSearchContext,
  provideTo: `bookingSearch`,
})
